var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('community',{attrs:{"data":_vm.com_par,"title":_vm.title[1]}}),_c('financial',{attrs:{"data":_vm.fin_anc,"title":_vm.title[2],"lst_acc":_vm.lst_acc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }